module.exports = __webpack_public_path__ + "static/biodegradable-382f157c4f66f854d695d9e753738ab3.png";